import axiosInstance from "../Interceptors/axiosInstance.jsx";

const publicJsonConfig = {
  skipAuth: true,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};

export const forgotPassword = async (email) => {
  const response = await axiosInstance.post(
    "auth/forgot-password",
    { email: email.trim() },
    publicJsonConfig
  );
  return response.data;
};

export const sendLoginOtp = async (emailAddress) => {
  const response = await axiosInstance.post(
    "auth/send-otp",
    { emailAddress: emailAddress.trim() },
    publicJsonConfig
  );
  return response.data;
};

export const resendLoginOtp = async (userId) => {
  const response = await axiosInstance.post(
    "auth/resend-otp",
    { userId },
    publicJsonConfig
  );
  return response.data;
};

export const verifyLoginOtp = async ({ userId, otp }) => {
  const response = await axiosInstance.post(
    "auth/verify-otp",
    { userId, otp },
    publicJsonConfig
  );
  return response.data;
};

export const resetPassword = async ({ token, newPassword, confirmPassword }) => {
  const response = await axiosInstance.post(
    "auth/reset-password",
    { token, newPassword, confirmPassword },
    publicJsonConfig
  );
  return response.data;
};

export const loginWithToken = async (token) => {
  const response = await axiosInstance.post(
    "auth/login-by-token",
    { token: token.trim() },
    publicJsonConfig
  );
  return response.data;
};
